export class LivanceTypedError extends Error {
  typeName: string;

  constructor(message: string, typeName: string) {
    super(message);
    this.name = typeName;
    this.typeName = typeName;
  }
}
